import { CategoryInput } from '@/features/eventMetadata/components/CategoryInput';
import type { ExperienceFeed } from '@/types/gql.generated';

type Props = {
  feed: ExperienceFeed;
  // Receives the selected category id, or null when the category is unassigned.
  // Each row wires this to its own update hook (feeds vs sources).
  onChange: (categoryId: string | null) => void;
  isReadOnly?: boolean;
};

export const FeedCategory = ({ feed, onChange, isReadOnly }: Props) => (
  <CategoryInput
    isReadOnly={isReadOnly}
    value={feed.category ?? null}
    onChange={(category) => onChange(category?.id ?? null)}
  />
);
